import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import React from 'react';
import styled from 'styled-components';
import defaultTheme from '../../../../themes/index';

interface Props {
  thisWeek: number;
  lastWeek: number;
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  line-height: 15px;
  width: 100%;
  align-items: center;
`;

const ContainerArrow = styled.div<Props>`
  color: ${props => getColor(props.thisWeek, props.lastWeek)};
  font-size: 1.2em;
  font-weight: bold;
  align-self: flex-start;
  margin-right: 3px;
  width: 11px;
`;

const BlankArrow = styled.span`
  font-size: 1.2em;
  font-weight: bold;
  align-self: flex-start;
  margin-right: 3px;
  width: 11px;
`;

function getColor(baseValue: number, actualValue: number) {
  if (baseValue > actualValue) return defaultTheme.palette.error.main;
  if (baseValue < actualValue) return defaultTheme.palette.success.main;
  return defaultTheme.palette.text.primary;
}

type RankInfoCellRendererProps = ICellRendererParams;

const RankInfoCellRenderer: React.FC<RankInfoCellRendererProps> = props => {
  const { value } = props;
  const formatValue = (v: number): string => {
    const { valueFormatter } = props.colDef;

    if (!valueFormatter || typeof valueFormatter === 'string') {
      return `${v}`;
    }
    return valueFormatter({ ...props, value: v });
  };

  const createSpan = (thisWeek: number, lastWeek: number) => {
    if (thisWeek === lastWeek || thisWeek < 0) {
      return <BlankArrow>&nbsp;</BlankArrow>;
    }
    if (lastWeek > thisWeek) {
      return (
        <ContainerArrow thisWeek={thisWeek} lastWeek={lastWeek}>
          &uarr;
          {/* ArrowUp */}
        </ContainerArrow>
      );
    }
    return (
      <ContainerArrow thisWeek={thisWeek} lastWeek={lastWeek}>
        &darr;
        {/* ArrowDown */}
      </ContainerArrow>
    );
  };

  const getElements = (): JSX.Element => {
    if (!value) return <></>;
    const obj = Object.values(value) as Array<number>;
    return (
      <Container>
        {createSpan(obj[0], obj[1])}
        <div>
          <span>{formatValue(obj[0])}</span>
          <br />
          <span>{formatValue(obj[1])}</span>
        </div>
      </Container>
    );
  };

  return getElements();
};

RankInfoCellRenderer.defaultProps = { value: undefined };

export default RankInfoCellRenderer;
